import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Right-hand "Auf dieser Seite" list with scroll-spy highlight (state owned by ArticleView)
export const Toc = ({ headings, activeId, onGo }) => {
  const { t } = useTranslation();

  if (!headings.length) return null;

  return (
    <>
      <Box
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          letterSpacing: '.12em',
          textTransform: 'uppercase',
          color: 'var(--text2)',
          marginBottom: '12px',
        }}
      >
        {t('On this page')}
      </Box>
      <Box className="flex flex-col">
        {headings.map((heading) => {
          const active = heading.id === activeId;
          return (
            <Box
              key={heading.id}
              component="button"
              onClick={() => onGo(heading.id)}
              className="cursor-pointer text-left"
              sx={{
                border: 'none',
                background: 'transparent',
                fontFamily: 'inherit',
                fontSize: '12px',
                fontWeight: active ? 600 : 500,
                color: active ? 'var(--accent-strong)' : 'var(--text2)',
                padding: `6px 0 6px ${(heading.level - 2) * 10 + 12}px`,
                borderLeft: `2px solid ${active ? 'var(--accent)' : 'var(--border)'}`,
                lineHeight: 1.4,
                ':hover': { color: 'var(--accent-strong)' },
              }}
            >
              {heading.text}
            </Box>
          );
        })}
      </Box>
    </>
  );
};
